"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselPauseControl = exports.CarouselPauseControlWrap = exports.CarouselContainer = exports.Arrow = exports.CarouselDefaultArrowStyles = exports.CarouselIndicatorItem = exports.CarouselIndicator = exports.CarouselIndicatorItemDot = exports.CarouselItem = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _styledComponents = require("styled-components");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  min-width: 24px;\n  min-height: 24px;\n  padding: 0;\n  border-radius: 50%;\n  margin-left: 5px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0 !important;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  .slick-track {\n    display: flex !important;\n  }\n\n  .slick-slide {\n    height: inherit !important;\n\n    & > div {\n      height: 100%;\n\n      & > div {\n        height: 100%;\n        vertical-align: top;\n\n        & > div {\n          margin: 0 auto;\n        }\n      }\n    }\n  }\n\n  .slick-dots {\n    list-style: none;\n    display: flex !important;\n    margin: 0;\n    padding: 40px 0;\n    background-color: ", ";\n    justify-content: center;\n\n    ", "\n\n    .slick-active {\n      ", " {\n        width: 11.32px;\n        height: 11.32px;\n        margin: -6px 0 0 -6px;\n      }\n    }\n  }\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: rgba(255, 255, 255, 0.5);\n  border: none;\n  display: flex;\n  left: 0;\n  min-height: 80px;\n  min-width: 20px;\n  max-height: 80px;\n  max-width: 20px;\n  padding: 0;\n  position: absolute;\n  top: calc(50% - 48px);\n  transform: translateY(-50%);\n  justify-content: center;\n  z-index: 1;\n\n  ", "\n\n  &:hover, &:active {\n    background: ", ";\n  }\n\n  ", " {\n    &:hover {\n      background: rgba(255, 255, 255, 0.5);\n    }\n    &:active {\n      background: ", " !important;\n    }\n  }\n\n  svg,\n  svg * {\n    fill: ", " !important;\n  }\n\n  svg {\n    position: relative;\n    left: -2%;\n  }\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 11.32px;\n  height: 11.32px;\n  display: block;\n  position: relative;\n  margin: 0 10px;\n\n  ", " {\n    width: ", "px;\n    height: ", "px;\n    margin: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  display: flex;\n  margin: 0;\n  padding: 40px 0;\n  background-color: ", ";\n  justify-content: center;\n\n  ", "\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background-color: ", ";\n  transform: rotate(45deg);\n  top: 50%;\n  left: 50%;\n  border: none;\n  overflow: hidden;\n  position: absolute;\n  padding: 0;\n  text-indent: -100px;\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n\n  & > div,\n  & .cq-Editable-dom > div {\n    height: 100%;\n    min-height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO improve type
var CarouselItem = (0, _uiKit.styled)('div')(_templateObject(), function (_ref) {
  var $active = _ref.$active;
  return $active ? 'block' : 'none';
});
exports.CarouselItem = CarouselItem;
var CarouselIndicatorItemDot = (0, _uiKit.styled)('button')(_templateObject2(), _uiKit.Colors.gray800);
exports.CarouselIndicatorItemDot = CarouselIndicatorItemDot;
var CarouselIndicator = (0, _uiKit.styled)('ol')(_templateObject3(), _uiKit.Colors.white, function (_ref2) {
  var inverse = _ref2.inverse;
  return inverse && (0, _styledComponents.css)(["background-color:transparent;", "{background-color:", ";}"], CarouselIndicatorItemDot, _uiKit.Colors.white);
}, function (_ref3) {
  var transparent = _ref3.transparent;
  return transparent && (0, _styledComponents.css)(["background-color:transparent;"]);
}); // TODO improve interface

exports.CarouselIndicator = CarouselIndicator;
var CarouselIndicatorItem = (0, _uiKit.styled)('span')(_templateObject4(), CarouselIndicatorItemDot, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? 11.32 : 5.66;
}, function (_ref5) {
  var $active = _ref5.$active;
  return $active ? 11.32 : 5.66;
}, function (_ref6) {
  var $active = _ref6.$active;
  return $active ? "-6px 0 0 -6px" : "-3px 0 0 -3px";
});
exports.CarouselIndicatorItem = CarouselIndicatorItem;
var CarouselDefaultArrowStyles = /*#__PURE__*/(0, _styledComponents.css)(["min-height:30px;max-height:30px;min-width:30px;max-width:30px;border-radius:50%;&:hover,&:active{background:transparent !important;}"]);
exports.CarouselDefaultArrowStyles = CarouselDefaultArrowStyles;
var Arrow = (0, _uiKit.styled)(_uiKit.Button)(_templateObject5(), function (_ref7) {
  var top = _ref7.top;
  return top && (0, _styledComponents.css)(["top:50%;"]);
}, _uiKit.Colors.white, _const.GridBreakpointsMediaDown.lg, _uiKit.Colors.white, _uiKit.Colors.black, function (_ref8) {
  var right = _ref8.right;
  return right && (0, _styledComponents.css)(["left:auto;right:0;svg{left:auto;right:-2%;}"]);
});
exports.Arrow = Arrow;
var CarouselContainer = (0, _uiKit.styled)("div")(_templateObject6(), function (_ref9) {
  var inverse = _ref9.inverse,
      transparent = _ref9.transparent;
  return inverse || transparent ? 'transparent' : _uiKit.Colors.white;
}, function (_ref10) {
  var inverse = _ref10.inverse;
  return inverse && (0, _styledComponents.css)(["", "{background-color:", ";}"], CarouselIndicatorItemDot, _uiKit.Colors.white);
}, CarouselIndicatorItemDot, function (_ref11) {
  var arrowStyle = _ref11.arrowStyle,
      arrowColor = _ref11.arrowColor,
      inverse = _ref11.inverse;
  return arrowStyle === 'flat' ? (0, _styledComponents.css)(["", "{background-color:transparent;svg,svg *{fill:", " !important;}}"], Arrow, inverse || arrowColor === 'light' ? _uiKit.Colors.white : _uiKit.Colors.black) : "";
});
exports.CarouselContainer = CarouselContainer;
var CarouselPauseControlWrap = (0, _uiKit.styled)('div')(_templateObject7());
exports.CarouselPauseControlWrap = CarouselPauseControlWrap;
var CarouselPauseControl = (0, _uiKit.styled)(_uiKit.Button)(_templateObject8());
exports.CarouselPauseControl = CarouselPauseControl;